// extracted by mini-css-extract-plugin
export default {"content":"Table_content__G3hj9","header":"Table_header__rB0Im","body":"Table_body__l4Enf","truncate":"Table_truncate__tPGeB","active":"Table_active__LSYjD"};